// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2rxGR","signatureButtonsRight":"ModalSign_signatureButtonsRight__IDZ3Z"};